'use strict';

wbApp.factory('emailAttachmentsSvc', ['$resource', '$translate', '$q', 'notificationSvc', 'repositorySvc',
    function ($resource, $translate, $q, notificationSvc, repositorySvc) {

        var EamilAttachments = $resource('/restapi/email-attachments/:id', {}, {
            'getFiles': { method: 'GET', isArray: true, url: '/restapi/email-attachments/:id' },
            'deleteFile': { method: 'DELETE', url: '/restapi/email-attachments/:id' },
            'getUploadUrl': { method: 'POST', url: '/restapi/email-attachments/create-upload-url/:id' },
        });

        function getFiles(documentTemplateType, emailCategory, localeAlias) {
            return repositorySvc.customGet(
                'getFiles',
                EamilAttachments,
                {
                    id: documentTemplateType,
                    emailCategory: emailCategory,
                    localeAlias: localeAlias || 'CS'
                });
        }

        function deleteFile(documentTemplateType, emailCategory, fileName, localeAlias) {
            return repositorySvc.customPostWithParams(
                'deleteFile',
                EamilAttachments,
                {
                    id: documentTemplateType,
                    fileName: fileName,
                    emailCategory: emailCategory,
                    localeAlias: localeAlias || 'CS'
                },
                null,
                null,
                null,
                true);
        }

        function getUploadUrl(documentTemplateType, emailCategory, fileName, localeAlias) {
            return repositorySvc.customPostWithParams(
                'getUploadUrl',
                EamilAttachments,
                {
                    id: documentTemplateType,
                    fileName: fileName,
                    emailCategory: emailCategory,
                    localeAlias: localeAlias || 'CS'
                },
                null,
                null,
                null,
                true);
        }

        return {
            getFiles: getFiles,
            deleteFile: deleteFile,
            getUploadUrl: getUploadUrl
        }
    }]);